// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.attachment-password__input .sk-input__input {\n  width: 100px;\n  height: 25px;\n}\n.attachment-password__input.sk-input {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
